export const Layer = {
    Modal: 'modals',
    Toast: 'toast',
}
